module.exports = __webpack_public_path__ + "static/media/peace.533158a0.svg";